import { DASHBOARD_LINK } from '@components/Router/constants'
import { Input } from '@lib/components'
import PrivateProjectLocked from '@lib/images/PrivateProjectLocked'
import { Button } from '@octopus-do/octopus-storybook'
import { ArrowRight } from '@octopus-do/octopus-storybook/icons'
import { managerActions } from '@store/reducers/manager/actions'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { openModal } from '@storeOld/reducers/ui.js'
import { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

import { checkPassword } from '@/services/project'
import { MODAL_AUTH, MODAL_NONE } from '../../App/Modal/constants'
import Octopus from '../../App/Octopus/Octopus'
import styles from './Blocker.module.css'

const Wrapper = (props) => (
  <div className={styles.container}>
    <div className={styles.outer}>
      <div className={styles.inner}>
        <div className={styles.octopus}>
          <Octopus width={80} height={80} />
        </div>
        <div className={styles.content}>{props.children}</div>
      </div>
    </div>
  </div>
)

const Archived = () => (
  <Wrapper>
    <div className={styles.heading}>Archived project</div>
    <div className={styles.body}>
      Bad news, the project owner decided to temporarily archive this project.
    </div>
  </Wrapper>
)

const Expired = (props) => (
  <Wrapper>
    <div className={styles.heading}>Expired project</div>
    <div className={styles.body}>
      Time to move forward. To reactivate your project you have to sign up and
      save it to your profile.
    </div>
    <div className={styles.footer}>
      <div className={styles.button} onClick={props.onClick}>
        Save
      </div>
    </div>
  </Wrapper>
)

const Password = ({ loggedIn = false }) => {
  const dispatch = useDispatch()
  const [password, setPassword] = useState('')

  const { uuid: projectId } = useParams()

  const handleLogin = () => {
    dispatch(openModal(MODAL_AUTH))
  }

  const handleSubmit = async () => {
    try {
      if (projectId) {
        const { token } = await checkPassword({
          password,
          projectId,
        })

        if (token) {
          localStorage.setItem(`pw_${projectId}`, token)
          window.location.reload()
        }
      }
    } catch (error) {
      console.error(error)

      dispatch(
        notificationActionCreators.setNotification({
          type: NotificationType.PASSWORD_PROTECTED_PASSWORD_ERROR,
        })
      )
    }
  }

  return (
    <div className={styles.privateProjectWrapper}>
      <div className={styles.privateProjectContainer}>
        <PrivateProjectLocked opacity={0.5} color="#ACBDD3" />

        <div className={styles.privateProjectHeading}>
          <div className={styles.privateProjectTitle}>Password protected</div>
          <p className={styles.privateProjectDescription}>
            Enter your password to access the project.
          </p>
        </div>

        <div className={styles.privateProjectInput}>
          <Input
            focusOnRender
            placeholder="Password"
            type="normal"
            htmlType="password"
            onChange={(value) => setPassword(value)}
            onSubmit={handleSubmit}
          />

          <Button
            left={ArrowRight}
            aria-label="Open the project"
            disabled={password.length < 1}
            onClick={handleSubmit}
          />
        </div>

        {!loggedIn && (
          <>
            <div className={styles.divider}>or</div>

            <p className={styles.loginHint}>
              Project or team member?{' '}
              <button
                type="button"
                className={styles.loginLink}
                onClick={handleLogin}
              >
                Log in
              </button>
            </p>
          </>
        )}
      </div>
    </div>
  )
}

const Private = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const handleSubmit = async (e) => {
    e.preventDefault()

    dispatch(openModal(MODAL_AUTH))
  }

  const handleRedirect = () => {
    navigate(DASHBOARD_LINK)
  }

  return (
    <div className={styles.privateProjectWrapper}>
      <div className={styles.privateProjectContainer}>
        <PrivateProjectLocked />

        <div className={styles.privateProjectHeading}>
          <div className={styles.privateProjectTitle}>Private project</div>
          <p className={styles.privateProjectDescription}>
            {props.loggedIn
              ? 'The project is only available to team or\u00A0project members. You don’t have access.'
              : 'The requested project is available only to project or team members'}
          </p>
        </div>

        {props.loggedIn ? (
          <Button
            priority="secondary"
            label="Go to my projects"
            onClick={handleRedirect}
          />
        ) : (
          <Button label="Sign In" onClick={handleSubmit} />
        )}
      </div>
    </div>
  )
}

const Blocker = (props) => {
  const dispatch = useDispatch()
  const url = window.location.href.split('/')

  const handleExpiredSaveClick = () => {
    dispatch({ type: managerActions.saveProjectSaga.type })
  }

  if (props.modalType !== MODAL_NONE) {
    return null
  }

  if (props.archived) {
    return <Archived />
  }

  if (props.password) {
    return <Password {...props} />
  }

  if (props.private) {
    return <Private {...props} />
  }

  if (props.expired) {
    return <Expired onClick={handleExpiredSaveClick} />
  }
  return null
}

const mapStateToProps = ({ ui, manager, auth }) => ({
  modalType: ui.modalType,
  loggedIn: auth.authenticated,
  projectId: manager.meta.id,
  archived: manager.meta.access.accessBlockerType === 'archived' || false,
  expired: manager.meta.access.accessBlockerType === 'expired' || false,
  private: manager.meta.access.accessBlockerType === 'private' || null,
  password: manager.meta.access.accessBlockerType === 'password' || null,
})

export default connect(mapStateToProps)(Blocker)
